import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  const token = JSON.parse(localStorage.getItem('token'));
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  if (token.role === 'user') {
    return <Navigate to="/" />;
  }
  return children;
};

export default PrivateRoute;
